import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AVAILABLE_SEMESTERS } from "./config";

export default function Intake() {
  const [selectedSemesters, setSelectedSemesters] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const semesters = AVAILABLE_SEMESTERS;
  const dropdownRef = useRef(null);

  const handleCheckboxChange = (semester) => {
    setSelectedSemesters((prev) =>
      prev.includes(semester)
        ? prev.filter((s) => s !== semester)
        : [...prev, semester]
    );
  };

  const handleSubmit = () => {
    localStorage.setItem("selectedSemesters", JSON.stringify(selectedSemesters));
    localStorage.setItem("semesterCourses", JSON.stringify({}));
    navigate("/intake/courses/0");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click target is not inside the dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
  
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setDropdownOpen(false);
      }
    };
  
    // Use 'click' instead of 'mousedown'
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
  
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);
  

  return (
    <div className="mx-auto mt-16 max-w-xl px-4">
      <div className="card space-y-6 p-8">
        <div className="text-center">
          <h2 className="font-display text-2xl font-semibold text-ink">
            Select completed semesters
          </h2>
          <p className="mt-1 text-sm text-ink-muted">
            Choose every semester you've taken courses — you'll add the courses next.
          </p>
        </div>

        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="input flex items-center justify-between text-left"
          >
            <span className={selectedSemesters.length ? "text-ink" : "text-ink-soft"}>
              {selectedSemesters.length > 0
                ? selectedSemesters.join(", ")
                : "Select semesters…"}
            </span>
          </button>

          {dropdownOpen && (
            <div className="absolute z-50 mt-1.5 max-h-60 w-full overflow-y-auto rounded-xl border border-line bg-surface py-1 shadow-lift">
              {semesters.map((semester) => (
                <label
                  key={semester}
                  className="flex cursor-pointer items-center gap-2.5 px-4 py-2 text-sm transition-colors hover:bg-surface-alt"
                >
                  <input
                    type="checkbox"
                    checked={selectedSemesters.includes(semester)}
                    onChange={() => handleCheckboxChange(semester)}
                    className="h-4 w-4 rounded border-line text-primary focus:ring-primary"
                  />
                  {semester}
                </label>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={handleSubmit}
          disabled={selectedSemesters.length === 0}
          className="btn-primary w-full"
        >
          Next
        </button>
      </div>
    </div>
  );
}
